module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-grid u-fixed u-pos-tl u-zindex--99 u-fit"
  }, [_vm._l((19), function(column, index) {
    return (_vm.$root.width > _vm.$root.breakpoints.sm) ? _c('div', {
      staticClass: "c-grid__column"
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((11), function(column, index) {
    return (_vm.$root.width <= _vm.$root.breakpoints.sm) ? _c('div', {
      staticClass: "c-grid__column-mobile"
    }) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7058acc"}!./src/scripts/components/app-grid/template.html
// module id = 149
// module chunks = 0